import styled from 'styled-components';

export const ShareWrapper = styled.div`
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  border-radius: ${props => props.theme.borderRadii.large};
  padding: 24px;
`;

export const TextWrapper = styled.div`
  text-align: center;
  width: 100%;
`;

export const StyledImg = styled.img`
  border-radius: ${props => props.theme.borderRadii.small};
  max-width: 100vw;
  width: 513px;
  height: 200px;
`;
